export default __webpack_public_path__ + "static/media/img_distribution-graph02.238d5288.png";